import React, { useState, useEffect } from "react";
import { Spinner, Table, Form } from "react-bootstrap";
import "../../Styles/yellocalfcss/pagecollect.css";
import ApiConfig from "../../api/ApiConfig";
import { simplePostCall } from "../../api/ApiServices";
import ScaleLoader from "react-spinners/ScaleLoader";
import { toast, ToastContainer } from "react-toastify";
import { CategoryScale } from "chart.js";

const CollectPayment = () => {
  const [studentList, setStudentList] = useState([]);
  const [invoiceList, setInvoiceList] = useState([]);
  const [bankList, setBankList] = useState([]); // --- NEW: Bank List State ---
  const [selectedInvoiceIds, setSelectedInvoiceIds] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isFetching, setIsFetching] = useState(true);
  const [isFetchingInvoices, setIsFetchingInvoices] = useState(false);
  const [categories, setCategories] = useState([]); 
  
  const [errors, setErrors] = useState({});

  const [formData, setFormData] = useState({
    studentId: "",
    paymentDate: new Date().toISOString().split("T")[0],
    paymentMode: "",
    bankId: "", // --- NEW: Bank ID field ---
    bankTxnNo: "BTXN" + Math.floor(Math.random() * 1000000),
    amount: "",
    transaction_payment_for:""
  });


console.log(formData);







    useEffect(() => {

    fetchCategories();
  }, []);
  const fetchCategories = async () => {
    try {
      const response = await simplePostCall(ApiConfig.categorytype, JSON.stringify({
        customer_id: Number(localStorage.getItem("customer_id")),
        api_key: localStorage.getItem("api_key"),
      }));
      if (response?.fee_category) setCategories(response.fee_category);
    } catch (error) { console.error("Categories fetch failed", error); }
  };
  // --- 1. Load Initial Data (Students & Banks) ---
  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        const payload = {
          customer_id: Number(localStorage.getItem("customer_id")),
          api_key: localStorage.getItem("api_key"),
        };

        // Fetch Students
        const studentRes = await simplePostCall(ApiConfig.studentlist, JSON.stringify(payload));
        if (studentRes?.studentList) setStudentList(studentRes.studentList);

        // --- NEW: Fetch Bank List ---
        // Replace 'ApiConfig.bankList' with your actual endpoint constant
        const bankRes = await simplePostCall(ApiConfig.bankList, JSON.stringify(payload));
        if (bankRes?.result) {
          setBankList(bankRes.data || []); 
        }

      } catch (error) {
        console.error("Error fetching initial data", error);
      } finally {
        setIsFetching(false);
      }
    };
    fetchInitialData();
  }, []);

  // --- 2. Fetch Invoices ---
  const fetchStudentInvoices = async (studentId) => {
    if (!studentId) {
      setInvoiceList([]);
      return;
    }
    setIsFetchingInvoices(true);
    try {
      const response = await simplePostCall(
        ApiConfig.pendingInvoice,
        JSON.stringify({
          customer_id: Number(localStorage.getItem("customer_id")),
          api_key: localStorage.getItem("api_key"),
          user_id: Number(localStorage.getItem("user_id")),
          language: "en",
          student_search: studentId,
          status_search: "",
        }),
      );

      if (response?.result) {
        setInvoiceList(response.data || []);
      }
    } catch (error) {
      console.error("Error fetching invoices", error);
    } finally {
      setIsFetchingInvoices(false);
    }
  };

  // --- 3. Validation Logic ---
  const validateForm = () => {
    let newErrors = {};

    if (!formData.studentId) newErrors.studentId = "Please select a student.";
    if (!formData.paymentMode) newErrors.paymentMode = "Select a payment mode.";
    if (!formData.paymentDate) newErrors.paymentDate = "Date is required.";
    
    // --- NEW: Bank Validation ---
    const needsBank = ["cash", "bank_transfer", "cheque", "dd"].includes(formData.paymentMode);
    if (needsBank && !formData.bankId) {
      newErrors.bankId = "Please select the deposit bank.";
    }

    const amountNum = parseFloat(formData.amount);
    if (!formData.amount || amountNum <= 0) {
      newErrors.amount = "Enter a valid amount greater than 0.";
    }

    if (selectedInvoiceIds.length === 0) {
      newErrors.invoices = "You must select at least one invoice.";
    }

    const selectedTotal = invoiceList
      .filter(inv => selectedInvoiceIds.includes(inv.fee_invoice_id))
      .reduce((sum, inv) => sum + parseFloat(inv.balance || 0), 0);

    if (amountNum > selectedTotal) {
      newErrors.amount = `Amount cannot exceed the total balance of selected invoices (${selectedTotal}).`;
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleStudentChange = (e) => {
    const id = e.target.value;
    setFormData({ ...formData, studentId: id });
    setSelectedInvoiceIds([]); 
    setErrors({ ...errors, studentId: "" });
    fetchStudentInvoices(id);
  };

  const handleInvoiceSelection = (invoiceId) => {
    setErrors({ ...errors, invoices: "" });
    setSelectedInvoiceIds((prev) =>
      prev.includes(invoiceId)
        ? prev.filter((id) => id !== invoiceId)
        : [...prev, invoiceId],
    );
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    if (errors[name]) setErrors({ ...errors, [name]: "" });
  };

  // --- 4. Final API Call ---
  const createcollectfee = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    setIsLoading(true);
    const requestBody = {
      customer_id: Number(localStorage.getItem("customer_id")),
      api_key: localStorage.getItem("api_key"),
      user_id: Number(localStorage.getItem("user_id")),
      language: "en",
      student_id: Number(formData.studentId),
      payment_mode: formData.paymentMode,
      bank_id: formData.bankId, // --- NEW: Included in payload ---
      transaction_payment_for: formData.transaction_payment_for, //CategoryScale api 
      transaction_mode: "bank_transfer",
      bank_transaction_no: formData.bankTxnNo,
      date: formData.paymentDate,
      invoice_ids: selectedInvoiceIds,
      paying_amount: Number(formData.amount),
      sandbox: 0,
    };

    try {
      const response = await simplePostCall(
        ApiConfig.collectparentpaymen,
        JSON.stringify(requestBody),
      );
      if (response?.result) {
        toast.success(response.message || "Payment Collected Successfully!");
        setFormData({
          studentId: "",
          paymentDate: new Date().toISOString().split("T")[0],
          paymentMode: "",
          bankId: "",
          bankTxnNo: "BTXN" + Math.floor(Math.random() * 1000000),
          amount: "",
        });
        setInvoiceList([]);
        setSelectedInvoiceIds([]);
      } else {
        toast.error(response?.message || "Error processing payment");
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong!");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="collectpayment-page-container my-2">
    <ToastContainer/>
      <div className="collectpayment-page-header">
        <h2 className="collectpayment-page-title">Collect Payment</h2>
      </div>

      {isFetching ? (
        <div className="d-flex justify-content-center">
          <ScaleLoader color="#F4BB44" style={{ textAlign: "center", padding: "10px" }} />
        </div>
      ) : (
        <div className="collectpayment-card">
          <form className="collectpayment-payment-form" onSubmit={createcollectfee}>
            
            {/* Student Selection */}
            <div className="collectpayment-form-row">
              <div className="collectpayment-form-group collectpayment-full-width">
                <label>Student Name <span className="collectpayment-required">*</span></label>
                <select
                  className={`form-select ${errors.studentId ? 'is-invalid' : ''}`}
                  name="studentId"
                  value={formData.studentId}
                  onChange={handleStudentChange}
                >
                  <option value="">Select Student</option>
                  {studentList.map((s) => (
                    <option key={s.student_id} value={s.student_id}>{s.student_name}</option>
                  ))}
                </select>
                {errors.studentId && <div className="text-danger small mt-1">{errors.studentId}</div>}
              </div>
            </div>

            {/* Invoices Table */}
            {formData.studentId && (
              <div className="invoice-section my-4">
                <h5 className={errors.invoices ? "text-danger" : ""}>Pending Invoices</h5>
                {isFetchingInvoices ? (
                  <Spinner animation="border" size="sm" />
                ) : (
                  <>
                    <Table striped bordered hover responsive size="sm" className={errors.invoices ? "border-danger" : ""}>
                      <thead>
                        <tr>
                          <th>Select</th>
                          <th>Invoice ID</th>
                          <th>Date</th>
                          <th>Balance</th>
                        </tr>
                      </thead>
                      <tbody>
                        {invoiceList.map((inv) => (
                          <tr key={inv.fee_invoice_id}>
                            <td>
                              <Form.Check
                                type="checkbox"
                                checked={selectedInvoiceIds.includes(inv.fee_invoice_id)}
                                onChange={() => handleInvoiceSelection(inv.fee_invoice_id)}
                              />
                            </td>
                            <td>{inv.fee_invoice_id}</td>
                            <td>{inv.fee_invoice_date}</td>
                            <td className="text-danger font-weight-bold">{inv.balance}</td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                    {errors.invoices && <div className="text-danger small">{errors.invoices}</div>}
                  </>
                )}
              </div>
            )}

            {/* Mode and Bank Selection */}
            <div className="collectpayment-form-row">
              
          <div className="col-md-6 col-12">
            <label className="form-label">Fee Category <span className="text-danger">*</span></label>
            <select 
                  name="transaction_payment_for"

              id="transaction_payment_for" 
              className={`form-select ${errors.transaction_payment_for ? 'is-invalid' : ''}`} 
              value={formData.transaction_payment_for} 
              onChange={handleChange}
            >
              <option value="">Select Category</option>
              {categories.map(cat => (
                <option key={cat.fee_category_id} value={cat.fee_category_name}>
                  {cat.fee_category_name}
                </option>
              ))}
            </select>
          </div>
              <div className="collectpayment-form-group collectpayment-half-width">
                <label>Payment Mode <span className="collectpayment-required">*</span></label>
                <select
                  className={`form-select ${errors.paymentMode ? 'is-invalid' : ''}`}
                  name="paymentMode"
                  value={formData.paymentMode}
                  onChange={handleChange}
                >
                  <option value="">Select Mode</option>
                  <option value="cash">Cash</option>
                  <option value="bank_transfer">Bank Transfer</option>
                  <option value="cheque">Cheque</option>
                  <option value="dd">DD</option>
                </select>
                {errors.paymentMode && <div className="text-danger small mt-1">{errors.paymentMode}</div>}
              </div>

              {/* --- NEW: Bank Select Button / Dropdown --- */}
              {["cash", "bank_transfer", "cheque", "dd"].includes(formData.paymentMode) && (
                <div className="collectpayment-form-group collectpayment-half-width">
                  <label>Select Bank <span className="collectpayment-required">*</span></label>
                  <select
                    className={`form-select ${errors.bankId ? 'is-invalid' : ''}`}
                    name="bankId"
                    value={formData.bankId}
                    onChange={handleChange}
                  >
                    <option value="">-- Choose Bank --</option>
                    {bankList.map((bank) => (
                      <option key={bank.bank_id} value={bank.bank_id}>
                        {bank.bank_name} {bank?.account_no ? (bank.account_no) : '' }
                      </option>
                    ))}
                  </select>
                  {errors.bankId && <div className="text-danger small mt-1">{errors.bankId}</div>}
                </div>
              )}
            </div>

            {/* Amount and Date */}
            <div className="collectpayment-form-row">
              <div className="collectpayment-form-group collectpayment-half-width">
                <label>Amount to Pay <span className="collectpayment-required">*</span></label>
                <input
                  type="number"
                  name="amount"
                  className={errors.amount ? "border-danger" : ""}
                  value={formData.amount}
                  onChange={handleChange}
                  placeholder="0.00"
                />
                {errors.amount && <div className="text-danger small mt-1">{errors.amount}</div>}
              </div>
              <div className="collectpayment-form-group collectpayment-half-width">
                <label>Payment Date <span className="collectpayment-required">*</span></label>
                <input
                  type="date"
                  name="paymentDate"
                  className={errors.paymentDate ? "border-danger" : ""}
                  value={formData.paymentDate}
                  onChange={handleChange}
                />
                {errors.paymentDate && <div className="text-danger small mt-1">{errors.paymentDate}</div>}
              </div>
            </div>

            {/* Txn No */}
            <div className="collectpayment-form-row">
              <div className="collectpayment-form-group collectpayment-full-width">
                <label>Transaction No / Reference</label>
                <input
                  type="text"
                  name="bankTxnNo"
                  value={formData.bankTxnNo}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="collectpayment-form-footer">
              <button
                type="submit"
                className="collectpayment-submit-btn"
                disabled={isLoading}
              >
                {isLoading ? <Spinner animation="border" size="sm" /> : "Collect Payment"}
              </button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
};

export default CollectPayment;